import { render, staticRenderFns } from "./GridVideoProviderUser.vue?vue&type=template&id=22430988&"
import script from "./GridVideoProviderUser.vue?vue&type=script&lang=js&"
export * from "./GridVideoProviderUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports